class SubscriptionPrice extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.shouldInit()) {
      this.init();

      this.onEventUnsubscriber = subscribe(
        'subscription-switched',
        this.switched.bind(this)
      );
    }
  }

  disconnectedCallback() {
    this.onEventUnsubscriber();
  }

  shouldInit() {
    if (document.body.dataset.priceSuperscript === undefined) {
      return false;
    }  

    const moneyFormat = theme.shopSettings.moneyFormat.toLowerCase();

    if (moneyFormat.indexOf('class=') !== -1) {
      return false;
    }

    if( ! document.querySelector('product-info')) {
      return false;
    }

    return true;
  }

  init() {
    const currencies_using_comma_decimals = 'ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,TRY,UYU,VES,VND'.split(',');
    const symbol = theme.shopSettings.moneyFormat.replace(/\{{.*}}/, '').trim();
    const bdis = this.querySelectorAll('bdi');

    const variant = this.getSelectedVariant(document.querySelector('product-info'));
    const subscription = this.getSubscription(variant);

    this.querySelector('.price__badge-subscription').innerHTML = subscription.frequency;
    let extra_discount = this.getAttribute('data-discount');
    if(this.getAttribute('data-discount')) {
      extra_discount = this.getAttribute('data-discount');
    }

    bdis.forEach(function(bdi){
      var price = `${subscription.price}`;
      var convert_price = 0.00;

      if(bdi.getAttribute('data-type') === 'compare_at') {
        price = subscription.compare_at_price;
      } else {
        var convert_price = parseFloat(price.replace(symbol, ''));

        if(extra_discount.includes('%')) {
          convert_price = (((100-parseInt(extra_discount))/100)*convert_price).toFixed(2);
        } else {
          convert_price = parseFloat(convert_price-parseFloat(extra_discount)).toFixed(2);
        }

        if (currencies_using_comma_decimals.includes(theme.shopSettings.isoCode)) {
          convert_price = convert_price.replace('.',',');
        }

        price = `${symbol}${convert_price}`;
      }

      let html = price.replace(' ', '');
      let money_symbol_decimal = '.';

      if (currencies_using_comma_decimals.includes(theme.shopSettings.isoCode)) {
        money_symbol_decimal = ',';
      }

      if (price.includes(money_symbol_decimal)) {
        if (price.lastIndexOf(symbol) + symbol.length === price.length) {
          const price_without_symbol = price.slice(0, price.lastIndexOf(symbol));
          const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
          const decimal = price_without_symbol.replace(price_without_decimal, '').trim();
          html = html.replace(decimal, `</span><sup class="price__suffix">${decimal}</sup>`);
        }
        else {
          const price_without_decimal = price.slice(0, price.lastIndexOf(money_symbol_decimal));
          const decimal = price.replace(price_without_decimal, '').trim();
          html = html.replace(decimal, `</span><sup class="price__suffix">${decimal}</sup>`);
        }
      }
      html = html.replace(symbol, `<span class="price__prefix">${symbol}</span><span class="price__main">`);
      
      if(theme.shopSettings.currencyCode){
        html = html + " " + theme.shopSettings.isoCode;
      }
      bdi.innerHTML = html;
    });

    this.switched({data: {
      item: document.querySelector('[name="subscription-option"]:checked'),
      onetime: document.querySelector(`.selling_plan_theme_integration[data-variant-id="${variant.id}"] .one-time-purchase input[type="radio"]`),
      subscription: document.querySelector(`.selling_plan_theme_integration[data-variant-id="${variant.id}"] .subscription-card input[type="radio"]`)
    }});
  }

  switched(response) {
    const data = response.data;
    const price = document.querySelector('.price');

    if( ! data.item) return;

    if(data.item.value === 'yes') {
        setTimeout(function(){
          document.querySelector('fh-selling-plans-widget').handleSellingPlanChange(document.querySelector('.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) option:checked'));
        }, 550);

        if(price.classList.contains('price--on-sale')){
          price.classList.remove('price--on-sale');
          price.classList.add('_price--on-sale');
        }

        price.classList.add('price--on-subscription');
      } else {
        setTimeout(function(){
          data.onetime.click();
          data.onetime.checked = true;

          const element = document.querySelector('.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) .one-time-purchase input');
          document.querySelector('fh-selling-plans-widget').dispatchSellingPlanChangedEvent(element, {
            variantId: element.dataset.variantId || null,
            sellingPlanId: null,
            price: element.dataset.price || null
          });
        }, 550);

        if(price.classList.contains('_price--on-sale')){
          price.classList.remove('_price--on-sale');
          price.classList.add('price--on-sale');
        }

        price.classList.remove('price--on-subscription');
      }
  }

  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }

  getSubscription(variant) {
    const selected = document.querySelector(`.selling_plan_theme_integration[data-variant-id="${variant.id}"] .subscription-card select`);
    const subscription = selected.options[selected.selectedIndex];

    return {
      'price' : subscription.getAttribute('data-price'),
      'compare_at_price' : subscription.getAttribute('data-variant-compare-at-price'),
      'price' : subscription.getAttribute('data-price'),
      'savings_text' : subscription.getAttribute('data-savings-text'),
      'savings_number' : parseInt(subscription.getAttribute('data-savings-text').replace(/\D/g, "")),
      'frequency' : subscription.text,
    };
  }
}
customElements.define('subscription-price', SubscriptionPrice);


class SubscriptionSwitch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.shouldInit()) {
      this.init();

      this.onEventUnsubscriber = subscribe(
        'subscription-variant-switched',
        this.switched.bind(this)
      );
    }
  }

  disconnectedCallback() {
    this.onEventUnsubscriber();
  }

  init() {
    this.data_title = this.querySelector('[data-type="title"]').innerHTML;

    const variant = this.getSelectedVariant(document.querySelector('product-info'));
    const subscription = this.getSubscription(variant);

    this.update(subscription);
  }

  shouldInit() {
    if (document.body.dataset.priceSuperscript === undefined) {
      return false;
    }  

    const moneyFormat = theme.shopSettings.moneyFormat.toLowerCase();

    if (moneyFormat.indexOf('class=') !== -1) {
      return false;
    }

    if( ! document.querySelector('product-info')) {
      return false;
    }

    return true;
  }

  update(subscription) {
    var title = this.data_title;

    title = title.replace('#savings_text', subscription.savings_text);
    title = title.replace('#savings_number', subscription.savings_number);
    this.querySelector('[data-type="title"]').innerHTML = title;
  }

  switched(response) {
    this.update(this.getSubscription(response.data.variant));
    const data = response.data;

    // TODO quick fix
    if(data.item.value === 'yes') {
        setTimeout(function(){
          document.querySelector('fh-selling-plans-widget').handleSellingPlanChange(document.querySelector('.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) option:checked'));
        }, 800);
      } else {
        setTimeout(function(){
          const element = document.querySelector('.selling_plan_theme_integration:not(.selling_plan_theme_integration--hidden) .one-time-purchase input');
          
          document.querySelector('fh-selling-plans-widget').dispatchSellingPlanChangedEvent(element, {
            variantId: element.dataset.variantId || null,
            sellingPlanId: null,
            price: element.dataset.price || null
          });
        }, 800);
      }
  }

  getSelectedVariant(node) {
    const selectedVariant = node.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }

  getSubscription(variant) {
    const selected = document.querySelector(`.selling_plan_theme_integration[data-variant-id="${variant.id}"] .subscription-card select`);
    const subscription = selected.options[selected.selectedIndex];

    return {
      'price' : subscription.getAttribute('data-price'),
      'compare_at_price' : subscription.getAttribute('data-variant-compare-at-price'),
      'price' : subscription.getAttribute('data-price'),
      'savings_text' : subscription.getAttribute('data-savings-text'),
      'savings_number' : parseInt(subscription.getAttribute('data-savings-text').replace(/\D/g, "")),
      'frequency' : subscription.text,
    };
  }
}
customElements.define('subscription-switch', SubscriptionSwitch);